'use strict';

var App = require('app');

var GatewayFirmwareConfig = Backbone.Model.extend({
    defaults: {
        modelType: 'gateway_firmware_config',
    },

    initialize: function (options) {
        this.device_id = options.device_id;
    },

    url: function () {
        var modelUrl = '/api/v1/devices/' + this.device_id + '/configuration';
        return modelUrl;
    },
});

var API = {
    getGatewayFirmwareConfig: function (device_id) {
        var defer = $.Deferred();
        var model = new GatewayFirmwareConfig({ device_id: device_id });

        model.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    writeGatewayFirmwareConfig: function (device_id, config) {
        var defer = $.Deferred();
        App.ajax({
            method: 'PUT',
            url: '/api/v1/devices/' + device_id + '/configuration',
            data: JSON.stringify(config),

            success: function (data) {
                return defer.resolve(data);
            },
            error: function (xhr) {
                return defer.resolve(undefined);
            },
        });
        return defer.promise();
    },
};

App.reqres.setHandler('gateway:firmwareconfig:read', function (device) {
    return API.getGatewayFirmwareConfig(device.id);
});

App.reqres.setHandler('gateway:firmwareconfig:write', function (device, config) {
    return API.writeGatewayFirmwareConfig(device.id, config);
});

module.exports = {
    Model: GatewayFirmwareConfig,
};
